export const EXTERNAL_BACKUP_SCHEDULE = '0 0 * * *'

export const EXTERNAL_BACKUP_RETENTION_DAYS = 7

export const OBJECT_STORAGE_NAME_MIN_LENGTH = 2

export const OBJECT_STORAGE_NAME_MAX_LENGTH = 64

export const getSuggestedObjectStorageName = (dbName: string) =>
  `${dbName}-backups`.slice(0, OBJECT_STORAGE_NAME_MAX_LENGTH)
